import {customElement} from 'aurelia-framework';

@customElement('sio-info-table')
export class InfoTable
{
    //Todo should get columns automatically?
}